// localStorage seguro: nunca rompe la app (modo privado, almacenamiento bloqueado, cuota llena).

export function readJSON<T>(clave: string, porDefecto: T): T {
  try {
    const raw = localStorage.getItem(clave);
    if (!raw) return porDefecto;
    const valor = JSON.parse(raw);
    if (porDefecto && typeof porDefecto === 'object' && !Array.isArray(porDefecto)) {
      return { ...porDefecto, ...valor };
    }
    return valor as T;
  } catch {
    return porDefecto;
  }
}

export function writeJSON(clave: string, valor: unknown) {
  try {
    localStorage.setItem(clave, JSON.stringify(valor));
  } catch {
    /* sin almacenamiento: la app sigue funcionando en memoria */
  }
}

export function remove(clave: string) {
  try {
    localStorage.removeItem(clave);
  } catch {
    /* nada */
  }
}

export const KEYS = {
  sesion: 'consola.sesion',
  apariencia: 'consola.apariencia',
  telefono: 'consola.telefono',
  recientes: 'consola.telefono.recientes',
  ultimoEmail: 'consola.ultimo-email',
} as const;
